import Button from './button';

export default (props) => {
    const { children, type = null } = props;

    return <Button { ...props } className={`button--${type !== null ? type : 'comment'}`} icon={type !== null ? type : 'comment'}>{ children ? children : 'Comment' }</Button>
}